/**
 * @generated SignedSource<<2146d5ab1ff461c0333e3630e508c9c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type avatarRelay_user$data = {
  readonly appType?: string | null | undefined;
  readonly picture: AGG$URL;
  readonly " $fragmentType": "avatarRelay_user";
};
export type avatarRelay_user$key = {
  readonly " $data"?: avatarRelay_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "avatarRelay_user",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "picture"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appType"
        }
      ],
      "type": "AppUser"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "507292d34580d58c48df1e1edacc7bad";

export default node;
